// axiosConfig.js

const API_CONFIG = {
  baseUrl: `${process.env.REACT_APP_API_URL_PROD}`,
  headers: {
    "Content-Type": "application/json",
  },
};

export default API_CONFIG;
